// The PHONE_MASK_CONFIG contains the mask for the phone number input.
// It can also be used to change the phone number format

import { DashboardStatus, PharmacyType } from '@/api/api.schemas';

// from XXXXXXXXXX to +1 XXX-XXX-XXXX format and vice versa.
export const PHONE_MASK_CONFIG = {
  mask: '___-___-__________',
  replacement: { _: /\d/ },
};

export const PATTERNS = {
  phone: /^[2-9][0-9]{9}$/,
  zip: /^\d{5}$/,
};

export const STATE_RULES = {
  existingPatientRelationshipNoPCPWorkaround: 2,
  existingPatientRelationshipPCPWorkaround: 3,
  faceToFaceRequiredToTreatAndPrescribeEveryVisit: 4,
  faceToFaceRequiredToTreatAndPrescribeOnce: 5,
  faceToFaceRequiredToTreatWithoutPrescribingEveryVisit: 6,
  facetToFaceRequiredToTreatWithoutPrescribingOnce: 7,
  noErxAllowed: 1,
  priorInPersonVisitAndFaceToFaceRequiredEveryTimeToTreatAndPresribe: 8,
  priorInPersonVisitRequiredToTreatAndPrescribe: 9,
};

export const SAVE_PROGRESS_LABEL = 'saveProgress';

export const US_PHONE_COUNTRY_CODE = '+1';

export const MAX_FILE_COUNT_MESSAGE = 3;
export const MAX_PHOTO_COUNT = 9;
export const MIN_PHOTO_COUNT = 2;

export const VISIT_SHOWN_AT_DASHBOARD = 5;

export const BIG_IMAGE_SIZE = 600;
export const MEDIUM_IMAGE_SIZE = 260;
export const SMALL_IMAGE_SIZE = 105;

export const ENCOUNTER_STATUS_IDS = {
  review: 600,
  payment: 650,
};

export const MAX_PAGES_COUNT = 7;

export const MAX_ADDRESS_LENGTH = 35;

export const MAX_STATE_LENGTH = 2;

export const REFERRED_PROVIDER_QUERY = 'r';

export const PAGE_SIZE_OPTIONS = ['10', '20', '30'] as const;

export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
export const MAX_FILE_COUNT = 6;
export const ACCEPTED_FILE_TYPES = '.pdf,.docx,.jpg,.png,.jpeg,.bmp,.heic,.heif';
export const ACCEPTED_IMAGE_TYPES =
  'image/jpeg,image/png,image/heif,image/heic,image/bmp,image/gif';

export const PHARMACY_TYPES = [PharmacyType.Retail, PharmacyType.MailOrder];

export const MAX_IDV_RETRIES = 1;
export const CONDITION_PAGE_STATUS_INCREMENT = 5;

export const START_VISIT_DASHBOARD_STATUSES: DashboardStatus[] = [
  DashboardStatus.Unknown,
  DashboardStatus.VisitCancelledByPatient,
  DashboardStatus.LastCompletedVisitWithinActivePeriod,
  DashboardStatus.TriagedOutByProvider,
];

export const VISIT_NOT_COMPLETED_DASHBOARD_STATUSES: DashboardStatus[] = [
  DashboardStatus.VisitInProgress,
  DashboardStatus.AwaitingTreatmentSelectedProvider,
  DashboardStatus.AwaitingTreatmentGeneralWaitingRoom,
  DashboardStatus.AwaitingTreatmentVideoRequired,
  DashboardStatus.VisitPausedForEdits,
];

export const DAYS_UNTIL_CANCELLATION = 7;
